<template>
  <footer class="dvs-bottom-bar">
    <div class="dvs-bottom-inner">
      <button
        v-if="showBack"
        type="button"
        class="dvs-btn-back"
        :disabled="loading"
        @click="$emit('back')"
      >
        <i class="bi bi-arrow-left dvs-btn-icon" aria-hidden="true"></i>
        <span class="dvs-btn-text">Atrás</span>
      </button>

      <button
        type="button"
        class="dvs-btn-primary"
        :disabled="loading"
        @click="$emit('next')"
      >
        <span v-if="loading" class="dvs-btn-content">
          <i class="bi bi-arrow-repeat dvs-btn-icon dvs-btn-spin" aria-hidden="true"></i>
          <span class="dvs-btn-text">{{ loadingLabel }}</span>
        </span>

        <span v-else class="dvs-btn-content">
          <i class="bi dvs-btn-icon" :class="nextIcon" aria-hidden="true"></i>
          <span class="dvs-btn-text">{{ nextLabel }}</span>
        </span>
      </button>
    </div>
  </footer>
</template>

<script setup>
defineProps({
  showBack: {
    type: Boolean,
    default: false
  },
  nextLabel: {
    type: String,
    default: 'Siguiente'
  },
  nextIcon: {
    type: String,
    default: 'bi-arrow-right'
  },
  loading: {
    type: Boolean,
    default: false
  },
  loadingLabel: {
    type: String,
    default: 'Enviando...'
  }
})

defineEmits(['back', 'next'])
</script>
